const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'API Access',
    apiAppContent: `With the Enlighten Systems API, software developers can write external applications that read system
          production data. These applications may ask you to enter a user id in order to make API requests on your
          behalf. Your user id is %{user_id}.`,
    showApp: 'Show applications that have API access',
    isGrantedApp: "You haven't granted API access to any applications.",
    apiSystemContent:
      'An external application can only retrieve data for systems that allow API access. This is controlled by the system owner. If a system you can view is not listed here, it is because the owner has chosen not to allow API access.',
    showSystem: 'Show systems that allow API access',
    isGrantedSystem: "You haven't granted API access to any systems.",
    revokeAccess: 'Revoke access'
  }
};

export default apiAccess;
